"use client";

import { SelectField } from "@repo/ui/form-fields";
import { useFieldBinding } from "@/shared/forms/connected-fields";

const DEFAULT_TIMEZONES = [
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Phoenix",
  "America/Anchorage",
  "Pacific/Honolulu",
  "UTC",
] as const;

export interface TimezoneFieldProps {
  label?: string;
  timezones?: readonly string[];
  disabled?: boolean;
}

export function TimezoneField({ label, timezones = DEFAULT_TIMEZONES, disabled }: TimezoneFieldProps) {
  const binding = useFieldBinding<string>();

  return (
    <SelectField
      {...binding}
      onChange={(v) => {
        if (v) binding.onChange(v);
        binding.onBlur();
      }}
      options={timezones.map((tz) => ({ value: tz, label: tz.replace("_", " ") }))}
      placeholder="Select timezone"
      label={label}
      disabled={disabled}
    />
  );
}
